// İletişim formu gönderimi — Web3Forms (ücretsiz, aylık 250 gönderim).
// Mesajlar info@mahirustaoto.com adresine iletilir.
// Anahtar REACT_APP_WEB3FORMS_KEY ile override edilebilir.
export const WEB3FORMS_KEY =
  process.env.REACT_APP_WEB3FORMS_KEY || "585ae65b-563c-482f-a6ec-7dc1030159cd";

const WEB3FORMS_URL = "https://api.web3forms.com/submit";

export async function sendContactMessage(payload) {
  if (!WEB3FORMS_KEY) {
    const err = new Error("no-endpoint");
    err.code = "no-endpoint";
    throw err;
  }

  const { name, phone, email, service, vehicle, message, page } = payload;

  // Web3Forms e-postada alan adlarını (key) etiket olarak gösterir → Türkçe key kullanıyoruz.
  // access_key / subject / from_name / replyto özel alanlardır, İngilizce kalmalı.
  const body = {
    access_key: WEB3FORMS_KEY,
    subject: `Web formu: ${service || "Genel"} — ${name}`,
    from_name: "Mahir Usta Oto Web Sitesi",
    replyto: email, // "Yanıtla" dediğinizde doğrudan müşteriye gider
    "Ad Soyad": name,
    Telefon: phone,
    "E-posta": email,
    Hizmet: service || "Belirtilmedi",
    "Araç": vehicle || "Belirtilmedi",
    "Mesaj": message,
    Sayfa: page,
  };

  const res = await fetch(WEB3FORMS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data.success) {
    const err = new Error(data.message || "send-failed");
    err.code = "send-failed";
    throw err;
  }
  return data;
}

export function buildWhatsAppLink(number, { name, phone, service, message }) {
  const text = [
    `Merhaba, web sitenizden yazıyorum.`,
    name && `Ad: ${name}`,
    phone && `Telefon: ${phone}`,
    service && `Hizmet: ${service}`,
    message && `Mesaj: ${message}`,
  ]
    .filter(Boolean)
    .join("\n");
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
